export default __webpack_public_path__ + "static/media/water3.bde3e202.png";